import { PressImagePreview} from "./PressImagePreview";

/** @type {NodeListOf<HTMLElement>} */
const pressImageTeasers = document.querySelectorAll('.tx-latest-photos-teaser[data-download-preview-enabled="true"]');

pressImageTeasers.forEach((teaser) => {
    /** @type {NodeListOf<HTMLElement>} */
    const pressImagePreviewItems = teaser.querySelectorAll('.tx-latest-photos-teaser-element');

    pressImagePreviewItems.forEach((item) => {
        new PressImagePreview(item, {
            overviewUrl: teaser.dataset.overviewUrl,
            labels: {
                download: teaser.dataset.labelDownload,
                overview: teaser.dataset.labelOverview,
            },
        });
    });
});
